import LoginState from '../interfaces/states/LoginState';

import * as Const from '../constants';

const initState: LoginState = {
  loginValue: '',
  error: false,
};

export default function login (state: LoginState = initState, action): LoginState {
  switch (action.type) {

    case Const.LOGIN_RECEIVE_SUCCESS:
      return {
        ...state,
        loginValue: action.payload,
        error: false,
      };

    case Const.LOGIN_RECEIVE_FAIL:
      return {
        ...state,
        loginValue: action.payload,
        error: true,
      };

    case Const.LOGIN_RECEIVE_INIT:
      return {
        ...state,
        loginValue: '',
        error: false,
      };

    default:
      return state;
  }
}
